var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M12.458 2.708h1.084v19.5h-1.084z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "m13.984 17.752.766.766-5.438 5.438-.766-.766z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "m17.474 23.196-.766.766-5.439-5.438.766-.766z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M2.167 4.333h21.666V19.5H2.167z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M1.625 3.792h22.75v2.167H1.625zm0 15.167h22.75v1.083H1.625zM16.25 23.563a.812.812 0 1 0 1.624 0 .812.812 0 0 0-1.624 0M8.125 23.563a.812.812 0 1 0 1.625 0 .812.812 0 0 0-1.625 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C51162",
    d: "m17.28 10.237-3.197 3.25-3.25-3.25-4.387 4.334 1.191 1.191 3.196-3.25 3.25 3.25 4.388-4.333z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C51162",
    d: "m19.5 13-3.792-3.792H19.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsOrder);
export default __webpack_public_path__ + "static/media/statisticsOrder.905127754657ebcc40a546c6171031af.svg";
export { ForwardRef as ReactComponent };